import { atom, useAtom } from 'jotai';
import { MatrixClient, Method } from 'matrix-js-sdk';
import { useCallback } from 'react';

export interface Ticket {
  uuid: string;
  project_code: string;
  ticket_no: string;
  create_time: string;
  last_modify_time: string;
  create_emp_code: string;
  to_emp_code: string;
  reply_emp_code: string;
  process_action: number;
  process_state: number;
  doc_no: string;
  summary: string;
  priority: number;
  status_id: number;
}

// Stores a flat list of tickets from the latest fetch operation.
const roomTicketsAtom = atom<Ticket[] | null>(null);

export const useRoomTicketsInfo = (mx: MatrixClient) => {
  const [tickets, setTickets] = useAtom(roomTicketsAtom);

  const fetchTicketsForRooms = useCallback(async (roomIds: string[], sort: 'asc' | 'desc' = 'desc') => {
    if (!roomIds || roomIds.length === 0) {
      setTickets(null);
      return null;
    }

    try {
      const response: { tickets: Ticket[] } = await mx.http.authedRequest(
        Method.Post,
        '/rooms/tickets',
        { sort },
        { roomids: roomIds }
      );

      setTickets(response.tickets);
      return response.tickets;
    } catch (error) {
      console.error('Failed to fetch room tickets info', error);
      setTickets(null);
      return null;
    }
  }, [mx, setTickets]);

  return { tickets, fetchTicketsForRooms };
};
